import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  Inject,
  Injector,
  Renderer2,
} from "@angular/core";
import { UsMapService } from "./us-map.service";
import { TuiDialogContext, TuiDialogService } from "@taiga-ui/core";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { POLYMORPHEUS_CONTEXT } from "@tinkoff/ng-polymorpheus";
import { element } from "protractor";
import { AntherMapComponent } from "../../dialog/anther-map/anther-map.component";
import { PolymorpheusComponent } from "@tinkoff/ng-polymorpheus";
import { AnotherMapComponent } from "./another-map/another-map.component";
@Component({
  selector: "us-map",
  templateUrl: "./us-map.component.html",
  styleUrls: ["./us-map.component.scss"],
})
export class UsMapComponent implements OnInit {
  showsTooltip = false;
  tooltipText: any;
  topPosition = 20;
  leftPosition = 415;
  //add =false;
  coordinates: any;
  selectedStates: string[] = [];
  stateList = [];
  isClicked = false;
  fillStyle: string;
  isSelected = false;
  @Input() fillColor: string = "#FFFFFF";
  @Input() fillStateColor: string = "#aeaeae";
  @Input() strokeColor: string = "#000000";
  @Output("onMapClick") click = new EventEmitter();
  // @ViewChild("myElement") myElement: ElementRef;
  @ViewChild("tooltip") tooltip: ElementRef;

  addData: Boolean = false;
  match = "MN";
  mapdata: any;
  constructor(
    private usMapService: UsMapService,
    private renderer: Renderer2,
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<any, any>,
    public globalvar: GlobalVarService,
    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector
  ) {
    const dialog = document.querySelector("tui-dialog");
    dialog.classList.add("stateMap");
    this.mapdata = context.data;
  }

  ngOnInit() {
    const tooltip = document.getElementById("tooltip");
    tooltip.style.display = "none";
    this.renderer.setStyle(tooltip, "display", "none");
    this.coordinates = this.usMapService.getUsMapCoordinates();
    const matchedObjects = this.coordinates.filter((object1) =>
      this.mapdata.some((object2) => object1.id.toLowerCase() === object2.id)
    );
    matchedObjects.forEach((element) => {
      this.stateList.push(element.id);
    });

    this.globalvar.checkedReciprocityMap.subscribe((state: string) => {
      if (state) {
        let checkState = this.stateList.filter(
          (element) => element == state.toUpperCase()
        );

        if (checkState.length == 0) {
          this.stateList.push(state.toUpperCase());
          document.getElementById(state.toUpperCase()).style["fill"] =
            "#103677";
        }
      }
    });
    // Unchecked Reciprocity State Items subscribe
    this.globalvar.UnCheckedReciprocityMap.subscribe((state) => {
      if (state) {
        let rsind = this.stateList.indexOf(state.toUpperCase());
        if (rsind != -1) {
          // this.stateList.splice(rsind, 1);
          // document.getElementById(state.toUpperCase()).style["fill"] = "#aeaeae";
        }
      }
    });
  }
  private openAnotherStateMap = this.dialogService.open<any>(
    new PolymorpheusComponent(AnotherMapComponent, this.injector),
    {
      dismissible: false,
      label: "",
      // size: "l",
    }
  );
  anotherMap() {
    // if (event.target.checked == true) {
    this.openAnotherStateMap = this.dialogService.open<any>(
      new PolymorpheusComponent(AnotherMapComponent, this.injector),
      {
        // data: this.stateModelvalue,
        dismissible: false,
        // size: "l",
      }
    );
    this.openAnotherStateMap.subscribe({
      next: (data: any) => {},
      complete: () => {},
    });
    // }
  }

  selectAll() {
    this.stateList = this.coordinates.map((state) => state.id);
    this.stateList.forEach((state) => {
      this.globalvar.AllsubscribeUSMapForChecked(state);
      /// this.globalvar.subscribeUSMapForChecked(state);
      document.getElementById(state).style["fill"] = "#103677";
    });
  }

  deselectAll() {
    this.stateList.forEach((state) => {
      this.globalvar.subscribeUSMapForUnChecked(state);
      document.getElementById(state).style["fill"] = "";
    });
    this.stateList = [];
  }

  fillcolor(colour: any) {
    const matchcolor = this.mapdata.filter(
      (element) => element?.id == colour.toLowerCase()
    );
    const findColor = matchcolor.length > 0 ? "#103677" : "#aeaeae";
    return findColor;
  }

  onUsMapClick(state) {
    if (this.stateList.length == 0) {
      this.stateList.push(state);
      this.globalvar.subscribeUSMapForChecked(state);
      this.isClicked = true;
      document.getElementById(state).style["fill"] = "#103677";
    } else if (this.stateList.length > 0) {
      if (this.stateList.indexOf(state) === -1) {
        this.isClicked = true;
        this.stateList.push(state);
        this.globalvar.subscribeUSMapForChecked(state);
        document.getElementById(state).style["fill"] = "#103677";
      } else {
        this.stateList.splice(this.stateList.indexOf(state), 1);
        this.globalvar.subscribeUSMapForUnChecked(state);
        document.getElementById(state).style["fill"] = "";
      }
    }
  }
  onmouseLeave(id) {
    if (this.stateList.length > 0) {
      const a = this.stateList.includes(id);
      if (a == true) {
        document.getElementById(id).style["fill"] = "#103677"; // selected blue
      } else {
        this.isClicked = false;
        document.getElementById(id).style["fill"] = "#aeaeae"; // unselect grey
      }
    } else {
      document.getElementById(id).style["fill"] = "";
    }
  }

  // onmouseLeave(id) {
  //   if (this.stateList.length > 0) {
  //     const a = this.stateList.includes(id);
  //     if (a == true) {
  //       this.isClicked = true;
  //     } else {
  //       if (this.isClicked == true) {
  //         document.getElementById(id).style["fill"] = "#103677";
  //       } else {
  //         this.isClicked = false;
  //         document.getElementById(id).style["fill"] = "#aeaeae";
  //       }
  //     }
  //   } else {
  //     if (!this.isClicked) {
  //       document.getElementById(id).style["fill"] = "#aeaeae";
  //     } else {
  //       this.isClicked = false;
  //     }
  //   }
  // }
  showtool: boolean = false;

  onHover(tooltipText: any, id, event: MouseEvent) {
    document.getElementById(id).style["fill"] = "#f26722"; //orange
    const mydiv = document.getElementById("myDIV");
    const tooltip = document.getElementById("tooltip");

    // Calculate the width and height of the tooltip
    let tooltipWidth = tooltip.offsetWidth;
    let tooltipHeight = tooltip.offsetHeight;

    // Calculate the x and y coordinates relative to myDIV
    let x =
      event.clientX - mydiv.getBoundingClientRect().left - tooltipWidth / 2;
    let y =
      event.clientY - mydiv.getBoundingClientRect().top - tooltipHeight / 2;

    // Set the position of the tooltip
    tooltip.style.left = x + "px";
    tooltip.style.top = y + "px";

    // Display the tooltip with the provided text
    tooltip.innerHTML = tooltipText;
    tooltip.style.display = "block";
    this.renderer.setStyle(tooltip, "left", x);
    this.renderer.setStyle(tooltip, "top", y);
    this.renderer.setStyle(tooltip, "display", "block");

    this.renderer.setProperty(
      this.tooltip.nativeElement,
      "innerHTML",
      tooltipText
    );
  }
  onMouseout() {
    const tooltip = document.getElementById("tooltip");
    tooltip.style.display = "none";
    this.renderer.setStyle(tooltip, "display", "none");
    //this.showsTooltip = false;
    this.tooltipText = "";
    this.topPosition = null;
    this.leftPosition = null;
  }

  close() {
    this.context.completeWith("");
    const dialog = document.querySelector("tui-dialog");
    dialog.classList.remove("stateMap");
  }
}
